import React from 'react';
import moment from 'moment-timezone';

import { basicReducer as reducer } from '../../../utils/reducers';
import { ProtectedRouteContext } from '../../Context';
import useStyles from './styles';

const initState = {
    doingAjax: false,
    quarter1StartUtc: null,
    show_quarter1StartUtcError: false,
    quarter1EndUtc: null,
    show_quarter1EndUtcError: false,
    quarter2StartUtc: null,
    show_quarter2StartUtcError: false,
    quarter2EndUtc: null,
    show_quarter2EndUtcError: false,
    quarter3StartUtc: null,
    show_quarter3StartUtcError: false,
    quarter3EndUtc: null,
    show_quarter3EndUtcError: false,
    quarter4StartUtc: null,
    show_quarter4StartUtcError: false,
    quarter4EndUtc: null,
    show_quarter4EndUtcError: false,
    errors: [
        {
            key: 'quarter1StartUtc',
            inError: true,
            errorMessage: 'Quarter Start Date is required.',
        },
        {
            key: 'quarter1EndUtc',
            inError: true,
            errorMessage: 'Quarter End Date is required.',
        },
        {
            key: 'quarter2StartUtc',
            inError: true,
            errorMessage: 'Quarter Start Date is required.',
        },
        {
            key: 'quarter2EndUtc',
            inError: true,
            errorMessage: 'Quarter End Date is required.',
        },
        {
            key: 'quarter3StartUtc',
            inError: true,
            errorMessage: 'Quarter Start Date is required.',
        },
        {
            key: 'quarter3EndUtc',
            inError: true,
            errorMessage: 'Quarter End Date is required.',
        },
        {
            key: 'quarter4StartUtc',
            inError: true,
            errorMessage: 'Quarter Start Date is required.',
        },
        {
            key: 'quarter4EndUtc',
            inError: true,
            errorMessage: 'Quarter End Date is required.',
        },
    ],
};

const useSchoolInfo = () => {
    const { userSettings } = React.useContext(ProtectedRouteContext);
    const [state, dispatch] = React.useReducer(reducer, {
        ...initState,
        tz: userSettings?.ClientTimeZone || 'America/New_York',
    });

    const styles = useStyles();

    const init = (datesObj) => {
        let {
            Quarter1StartUTC,
            Quarter1EndUTC,
            Quarter1NumDays,
            Quarter2StartUTC,
            Quarter2EndUTC,
            Quarter2NumDays,
            Quarter3StartUTC,
            Quarter3EndUTC,
            Quarter3NumDays,
            Quarter4StartUTC,
            Quarter4EndUTC,
            Quarter4NumDays,
        } = datesObj;

        let parsedState = {
            quarter1StartUtc: Quarter1StartUTC ? moment.tz(Quarter1StartUTC, state.tz) : null,
            quarter1EndUtc: Quarter1EndUTC ? moment.tz(Quarter1EndUTC, state.tz) : null,
            quarter1NumDays: Quarter1NumDays || '',
            quarter2StartUtc: Quarter2StartUTC ? moment.tz(Quarter2StartUTC, state.tz) : null,
            quarter2EndUtc: Quarter2EndUTC ? moment.tz(Quarter2EndUTC, state.tz) : null,
            quarter2NumDays: Quarter2NumDays || '',
            quarter3StartUtc: Quarter3StartUTC ? moment.tz(Quarter3StartUTC, state.tz) : null,
            quarter3EndUtc: Quarter3EndUTC ? moment.tz(Quarter3EndUTC, state.tz) : null,
            quarter3NumDays: Quarter3NumDays || '',
            quarter4StartUtc: Quarter4StartUTC ? moment.tz(Quarter4StartUTC, state.tz) : null,
            quarter4EndUtc: Quarter4EndUTC ? moment.tz(Quarter4EndUTC, state.tz) : null,
            quarter4NumDays: Quarter4NumDays || '',
        };

        let newErrors = initState?.errors;

        for (let key in parsedState) {
            if (parsedState[key]) newErrors = newErrors.filter((err) => err?.key !== key);
        }

        parsedState.errors = newErrors;

        dispatch({
            type: 'update',
            newState: parsedState,
        });
    };

    const handleDateChange = (date, key) => {
        let newState = {
            [key]: date,
            [`show_${key}Error`]: false,
        };

        let error = { key };

        if (date === null) {
            error.inError = true;
            error.errorMessage = `${key.includes('Start') ? 'Start' : 'End'} Date is required.`;

            newState.errors = [...state?.errors?.filter((err) => err?.key !== key), error];
        }

        dispatch({
            type: 'update',
            newState,
        });
    };

    const handleDateBlur = (key) => {
        let newState = {
            [`show_${key}Error`]: true,
        };

        dispatch({
            type: 'update',
            newState,
        });
    };

    const handleDateError = (err, val, key) => {
        let _err = state?.errors?.find((err) => err?.key === key) || {
            key,
        };

        if (val === null || val?.toISOString?.() === null) {
            _err.inError = true;
            _err.errorMessage = `${key.includes('Start') ? 'Start' : 'End'} Date is required.`;
        } else if (err === 'minDate') {
            _err.inError = true;
            _err.errorMessage = `${key.includes('Start') ? 'Start' : 'End'} Date must be more recent.`;
        } else if (err === 'maxDate') {
            _err.inError = true;
            _err.errorMessage = `${key.includes('Start') ? 'Start' : 'End'} Date must be in the past.`;
        } else if (err === null) {
            _err.inError = false;
            _err.errorMessage = null;
        } else return;

        dispatch({
            type: 'update',
            newState: {
                errors:
                    _err?.inError === true
                        ? [...state?.errors?.filter((err) => err?.key !== key), _err]
                        : [...state?.errors?.filter((err) => err?.key !== key)],
            },
        });
    };

    const handleDayChange = (event, key) => {
        dispatch({
            type: 'update',
            newState: {
                [key]: parseInt(event.target.value) || '',
            },
        });
    };

    return {
        state,
        ...styles,
        init,
        handleDateChange,
        handleDateBlur,
        handleDateError,
        handleDayChange,
    };
};

export default useSchoolInfo;
